import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { RedImmobile, RedFirmaDigitale } from '../../../types/red'
import { redApi } from '../../../services/api'

const STATO_CONFIG: Record<string, { label: string; color: string; bg: string }> = {
  bozza:       { label: 'Bozza',       color: '#6b7280', bg: '#f3f4f6' },
  inviato:     { label: 'Inviato',     color: '#1d4ed8', bg: '#dbeafe' },
  firmato_1:   { label: 'Firmato 1°',  color: '#b45309', bg: '#fef3c7' },
  firmato_2:   { label: 'Firmato 2°',  color: '#b45309', bg: '#fef3c7' },
  completato:  { label: 'Completato',  color: '#15803d', bg: '#dcfce7' },
  rifiutato:   { label: 'Rifiutato',   color: '#b91c1c', bg: '#fee2e2' },
}

const TabFirmaDigitale: React.FC<{ immobile: RedImmobile; onUpdate: () => void }> = ({ immobile, onUpdate }) => {
  const [firme, setFirme] = useState<RedFirmaDigitale[]>([])
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({
    tipo_documento: 'contratto_appalto',
    titolo: '',
    firmatario_1_nome: '',
    firmatario_1_cf: '',
    firmatario_1_email: '',
    firmatario_2_nome: '',
    firmatario_2_cf: '',
    firmatario_2_email: '',
    note: '',
  })

  const load = () => {
    redApi.firmaDigitale.listByImmobile(immobile.id).then(res => {
      setFirme(res.data)
      setLoading(false)
    })
  }

  useEffect(load, [immobile.id])

  const handleCreate = async () => {
    if (!form.titolo || !form.firmatario_1_nome) {
      toast.error('Titolo e primo firmatario sono obbligatori')
      return
    }
    try {
      await redApi.firmaDigitale.create({
        immobile_id: immobile.id,
        tipo_documento: form.tipo_documento,
        titolo: form.titolo,
        firmatario_1_nome: form.firmatario_1_nome,
        firmatario_1_cf: form.firmatario_1_cf || null,
        firmatario_1_email: form.firmatario_1_email || null,
        firmatario_2_nome: form.firmatario_2_nome || null,
        firmatario_2_cf: form.firmatario_2_cf || null,
        firmatario_2_email: form.firmatario_2_email || null,
        note: form.note || null,
      })
      toast.success('Richiesta firma creata')
      setShowForm(false)
      setForm({
        tipo_documento: 'contratto_appalto', titolo: '',
        firmatario_1_nome: '', firmatario_1_cf: '', firmatario_1_email: '',
        firmatario_2_nome: '', firmatario_2_cf: '', firmatario_2_email: '',
        note: '',
      })
      load()
      onUpdate()
    } catch {
      toast.error('Errore creazione')
    }
  }

  const handleInvia = async (id: string) => {
    try { await redApi.firmaDigitale.invia(id); toast.success('Inviato'); load() } catch { toast.error('Errore') }
  }

  const handleFirma = async (id: string, num: number) => {
    try { await redApi.firmaDigitale.firma(id, num); toast.success(`Firma ${num} registrata`); load() } catch { toast.error('Errore') }
  }

  if (loading) return <div className="text-gray-400">Caricamento firme...</div>

  return (
    <div className="max-w-4xl space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-800">✍️ Firma Digitale</h2>
        <button onClick={() => setShowForm(v => !v)} className="btn-primary text-sm">
          {showForm ? 'Annulla' : '+ Nuova richiesta'}
        </button>
      </div>

      {showForm && (
        <div className="card p-4 grid grid-cols-2 md:grid-cols-3 gap-3">
          <div>
            <label className="label">Tipo documento</label>
            <select className="select" value={form.tipo_documento} onChange={e => setForm({ ...form, tipo_documento: e.target.value })}>
              <option value="contratto_appalto">Contratto Appalto</option>
              <option value="compromesso">Compromesso</option>
              <option value="rogito">Rogito</option>
              <option value="proposta_acquisto">Proposta Acquisto</option>
              <option value="altro">Altro</option>
            </select>
          </div>
          <div className="col-span-2">
            <label className="label">Titolo *</label>
            <input className="input" value={form.titolo} onChange={e => setForm({ ...form, titolo: e.target.value })} placeholder="Es. Contratto appalto IMECO" />
          </div>
          <div>
            <label className="label">Firmatario 1 *</label>
            <input className="input" value={form.firmatario_1_nome} onChange={e => setForm({ ...form, firmatario_1_nome: e.target.value })} placeholder="Nome e cognome" />
          </div>
          <div>
            <label className="label">CF Firmatario 1</label>
            <input className="input" value={form.firmatario_1_cf} onChange={e => setForm({ ...form, firmatario_1_cf: e.target.value })} maxLength={16} />
          </div>
          <div>
            <label className="label">Email Firmatario 1</label>
            <input className="input" type="email" value={form.firmatario_1_email} onChange={e => setForm({ ...form, firmatario_1_email: e.target.value })} />
          </div>
          <div>
            <label className="label">Firmatario 2</label>
            <input className="input" value={form.firmatario_2_nome} onChange={e => setForm({ ...form, firmatario_2_nome: e.target.value })} placeholder="Nome e cognome" />
          </div>
          <div>
            <label className="label">CF Firmatario 2</label>
            <input className="input" value={form.firmatario_2_cf} onChange={e => setForm({ ...form, firmatario_2_cf: e.target.value })} maxLength={16} />
          </div>
          <div>
            <label className="label">Email Firmatario 2</label>
            <input className="input" type="email" value={form.firmatario_2_email} onChange={e => setForm({ ...form, firmatario_2_email: e.target.value })} />
          </div>
          <div className="col-span-3">
            <button onClick={handleCreate} className="btn-primary">Crea richiesta firma</button>
          </div>
        </div>
      )}

      <div className="space-y-3">
        {firme.map(f => {
          const cfg = STATO_CONFIG[f.stato] || STATO_CONFIG.bozza
          return (
            <div key={f.id} className="bg-white border border-gray-200 rounded-xl p-4">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <div className="text-sm font-medium text-gray-800">{f.titolo}</div>
                  <div className="text-xs text-gray-500">{f.tipo_documento.replace(/_/g, ' ')}</div>
                </div>
                <span className="text-xs font-medium px-2 py-0.5 rounded-full" style={{ color: cfg.color, backgroundColor: cfg.bg }}>
                  {cfg.label}
                </span>
              </div>

              <div className="grid grid-cols-2 gap-4 text-sm mb-3">
                <div className={`p-2 rounded-lg border ${f.firmatario_1_firmato ? 'bg-green-50 border-green-200' : 'bg-gray-50 border-gray-200'}`}>
                  <div className="text-xs text-gray-500">Firmatario 1</div>
                  <div className="font-medium">{f.firmatario_1_nome || '—'}</div>
                  {f.firmatario_1_firmato && <div className="text-xs text-green-600">✓ Firmato {f.firmatario_1_data_firma ? new Date(f.firmatario_1_data_firma).toLocaleDateString('it-IT') : ''}</div>}
                </div>
                <div className={`p-2 rounded-lg border ${f.firmatario_2_firmato ? 'bg-green-50 border-green-200' : 'bg-gray-50 border-gray-200'}`}>
                  <div className="text-xs text-gray-500">Firmatario 2</div>
                  <div className="font-medium">{f.firmatario_2_nome || '—'}</div>
                  {f.firmatario_2_firmato && <div className="text-xs text-green-600">✓ Firmato {f.firmatario_2_data_firma ? new Date(f.firmatario_2_data_firma).toLocaleDateString('it-IT') : ''}</div>}
                </div>
              </div>

              <div className="flex items-center gap-2">
                {f.stato === 'bozza' && (
                  <button onClick={() => handleInvia(f.id)} className="text-xs bg-blue-600 text-white px-3 py-1.5 rounded hover:bg-blue-700">📤 Invia ai firmatari</button>
                )}
                {f.stato === 'inviato' && (
                  <>
                    <button onClick={() => handleFirma(f.id, 1)} className="text-xs bg-green-600 text-white px-3 py-1.5 rounded hover:bg-green-700">✍️ Registra firma 1°</button>
                    {f.firmatario_2_nome && (
                      <button onClick={() => handleFirma(f.id, 2)} className="text-xs bg-green-600 text-white px-3 py-1.5 rounded hover:bg-green-700">✍️ Registra firma 2°</button>
                    )}
                  </>
                )}
                {(f.stato === 'firmato_1' || f.stato === 'firmato_2') && (
                  <button onClick={() => handleFirma(f.id, f.stato === 'firmato_1' ? 2 : 1)} className="text-xs bg-green-600 text-white px-3 py-1.5 rounded hover:bg-green-700">
                    ✍️ Registra firma {f.stato === 'firmato_1' ? '2°' : '1°'}
                  </button>
                )}
                <button
                  onClick={async () => { if (!confirm('Eliminare?')) return; try { await redApi.firmaDigitale.delete(f.id); toast.success('Eliminato'); load() } catch { toast.error('Errore') } }}
                  className="text-xs text-red-500 hover:text-red-700 ml-auto"
                >
                  🗑
                </button>
              </div>
            </div>
          )
        })}
        {firme.length === 0 && (
          <div className="text-center py-10 text-gray-400">Nessuna richiesta di firma digitale.</div>
        )}
      </div>
    </div>
  )
}

export default TabFirmaDigitale
